<template>
  <div id="app">
    <!-- 路由出口，路由匹配到的组件将渲染到这里-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
  // 让默认样式失效
  html, body, h3, p {
    margin: 0;
    padding: 0
  }
  .el-tooltip__popper {
    max-width: 300px;
  }

  .el-date-picker .el-date-table__row .badge::after {
  position: absolute;
  content: "";
  right: 8px;
  top: 8px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: red;
}
</style>